import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Layout from "@/components/Layout";
import HomePage from "@/pages/HomePage";
import AboutPage from "@/pages/AboutPage";
import ServicesPage from "@/pages/ServicesPage";
import ProjectsPage from "@/pages/ProjectsPage";
import ContactPage from "@/pages/ContactPage";
import BlogPage from "@/pages/BlogPage";
import BlogPostPage from "@/pages/BlogPostPage";
import ServiceDetailPage from "@/pages/ServiceDetailPage";
import CityLandingPage from "@/pages/CityLandingPage";
import ScaffoldingRentalPage from "@/pages/ScaffoldingRentalPage";
import ShutteringRentalPage from "@/pages/ShutteringRentalPage";
import GalleryPage from "@/pages/GalleryPage";
import TestimonialsPage from "@/pages/TestimonialsPage";
import ScaffoldingOnHirePage from "@/pages/ScaffoldingOnHirePage";
import TeamCardPage from "@/pages/TeamCardPage";
import TeamAdminPage from "@/pages/TeamAdminPage";

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<HomePage />} />
          <Route path="about" element={<AboutPage />} />
          <Route path="services" element={<ServicesPage />} />
          <Route path="projects" element={<ProjectsPage />} />
          <Route path="gallery" element={<GalleryPage />} />
          <Route path="testimonials" element={<TestimonialsPage />} />
          <Route path="contact" element={<ContactPage />} />
          <Route path="scaffolding-on-hire" element={<ScaffoldingOnHirePage />} />
          <Route path="blog" element={<BlogPage />} />
          <Route path="blog/:slug" element={<BlogPostPage />} />
          
          {/* Service Pages */}
          <Route path="scaffolding-rental" element={<ScaffoldingRentalPage />} />
          <Route path="shuttering-material-on-rent" element={<ShutteringRentalPage />} />
          <Route path="cuplock-scaffolding" element={<ServiceDetailPage service="cuplock-scaffolding" />} />
          <Route path="acrow-span-props" element={<ServiceDetailPage service="acrow-span-props" />} />
          <Route path="industrial-scaffolding" element={<ServiceDetailPage service="industrial-scaffolding" />} />
          <Route path="scaffolding-for-high-rise-projects" element={<ServiceDetailPage service="high-rise" />} />
          
          {/* City Landing Pages */}
          <Route path="scaffolding-rental-noida" element={<CityLandingPage city="noida" />} />
          <Route path="scaffolding-rental-delhi-ncr" element={<CityLandingPage city="delhi-ncr" />} />
          <Route path="scaffolding-rental-hyderabad" element={<CityLandingPage city="hyderabad" />} />
          <Route path="scaffolding-rental-vizag" element={<CityLandingPage city="vizag" />} />
          
          {/* Team Digital Cards */}
          <Route path="team/:slug" element={<TeamCardPage />} />
        </Route>
        
        {/* Admin Panel - Outside Layout (no header/footer) */}
        <Route path="admin/team" element={<TeamAdminPage />} />
      </Routes>
    </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
